<template>
  <div class="about_invite">
    <ul class="cont_list">
      <li>
        <router-link to="/content" class="clearfloat newslist_new">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">4畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策，同心协力谋发展 省交通监理公司召开同心协力谋发展 省交通监理公司召开</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
      <li>
        <router-link to="" class="clearfloat">
          <div class="fr">2020-02-02</div>
          <div class="inner single-line">畅所欲言献良策，同心协力谋发展 省交通监理公司召开畅所欲言献良策</div>
        </router-link>
      </li>
    </ul>

    <div class="cont_list_pag">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="currentPage"
        @current-change = "currentPag">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'policyCommon',
  data(){
    return{
      total: 25,
      currentPage: 1
    }
  },
  mounted: function(){
    var _this = this

    _this.currentPag(_this.currentPage)
  },
  methods: {
    currentPag(index){
      console.log('index :>> ', index);
    }

  }
}
</script>